/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { Row, Col } from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { useLocation } from 'react-router-dom';

// eslint-disable-next-line import/no-unresolved
import bwipjs from 'bwip-js';

function PalletLabels(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const location = useLocation();
  const pallets = location.state?.pallets;

  const { t } = props;

  const generateDataMatrix = (text) => {
    try {
      // Use bwip-js to generate the barcode
      const canvas = document.createElement('canvas');
      bwipjs.toCanvas(canvas, {
        bcid: 'datamatrix', // Barcode type
        text, // Content of the barcode
        scale: 9, // Scale factor for better resolution
        includetext: false, // Exclude text below the barcode
        backgroundcolor: 'ffffff', // White background
      });
      return canvas.toDataURL(); // Convert canvas to Base64 image
    } catch (err) {
      return null;
    }
  };

  function chunkArray(array, size) {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  return (
    <div>
      {chunkArray(pallets, 2).map((palletGroup, pageIndex) => (
        <div className="page" key={`_${pageIndex}`}>
          <Row>
            {palletGroup.map((pallet) => (
              <>
                <Col sm="6" className="postition-relative">
                  <div
                    style={{
                      fontSize: '100px',
                      position: 'absolute',
                      left: '7%',
                      top: '4%',
                    }}
                  >
                    {pallet.id.toString(36).toUpperCase()}
                  </div>
                  <div
                    style={{
                      fontSize: '100px',
                      position: 'absolute',
                      right: '7%',
                      top: '4%',
                      border: '5px dashed #484848',
                      padding: '2px',
                      borderRadius: '8px',
                    }}
                  >
                    {pallet.class.toUpperCase()}
                  </div>

                  <div className="barcode">
                    <img src={generateDataMatrix(`.${pallet.id}`)} alt={`Barcode for ${pallet.id}`} />
                  </div>

                  <div
                    style={{
                      fontSize: '100px',
                      position: 'absolute',
                      left: '7%',
                      bottom: '7%',
                    }}
                  >
                    {pallet.id.toString(36).toUpperCase()}
                  </div>
                  <div
                    style={{
                      fontSize: '100px',
                      position: 'absolute',
                      right: '7%',
                      bottom: '5%',
                      border: '5px dashed #484848',
                      padding: '2px',
                      borderRadius: '8px',
                    }}
                  >
                    {pallet.class.toUpperCase()}
                  </div>
                </Col>

                <Col sm="6" className="postition-relative">
                  <div
                    style={{
                      fontSize: '100px',
                      position: 'absolute',
                      left: '7%',
                      top: '4%',
                    }}
                  >
                    {pallet.id.toString(36).toUpperCase()}
                  </div>
                  <div
                    style={{
                      fontSize: '100px',
                      position: 'absolute',
                      right: '7%',
                      top: '4%',
                      border: '5px dashed #484848',
                      padding: '2px',
                      borderRadius: '8px',
                    }}
                  >
                    {pallet.class.toUpperCase()}
                  </div>

                  <div className="barcode">
                    <img src={generateDataMatrix(`.${pallet.id}`)} alt={`Barcode for ${pallet.id}`} />
                  </div>

                  <div
                    style={{
                      fontSize: '100px',
                      position: 'absolute',
                      left: '7%',
                      bottom: '7%',
                    }}
                  >
                    {pallet.id.toString(36).toUpperCase()}
                  </div>
                  <div
                    style={{
                      fontSize: '100px',
                      position: 'absolute',
                      right: '7%',
                      bottom: '5%',
                      border: '5px dashed #484848',
                      padding: '2px',
                      borderRadius: '8px',
                    }}
                  >
                    {pallet.class.toUpperCase()}
                  </div>
                </Col>
              </>
            ))}
          </Row>

          <div style={{ clear: 'left' }} />
        </div>
      ))}

      <style>
        {`
          @page {
            size: letter;
            margin: 0mm;
            padding: 0mm;
          }
          
          body {
            margin: 0mm;
          }
          
          .col-sm-6 {
             float: left;
             width: 39%;
             height:136.4mm;
             padding:1%;
          }
          
          .page {
            height: 134.5mm;
            width: 279mm;
            page-break-after: always;
            page-break-inside: avoid;
            break-after: page;
          }

          .page:last-of-type {
            page-break-after: auto;
          }
          
          .barcode {
            position:absolute;
            left:26%;
            top:32%;
          }
        `}
      </style>
    </div>
  );
}

PalletLabels.defaultProps = {
  t: (x) => (x),
};

PalletLabels.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(PalletLabels));
